module.exports = __webpack_public_path__ + "static/media/Galileo_weaponUp.d1b779f8.wav";


//////////////////
// WEBPACK FOOTER
// ./src/sound/Galileo_weaponUp.wav
// module id = 193
// module chunks = 0